export default {
  'store.giftCard.list.title': '禮品卡列表',
  'store.giftCard.list.create': '新建禮品卡',
  'store.giftCard.list.refresh': '刷新',
  'store.giftCard.list.search.cardId': '卡號',
  'store.giftCard.list.search.phone': '手機號',
  'store.giftCard.list.search.email': '郵箱',
  'store.giftCard.list.search.status': '狀態',
  'store.giftCard.list.table.cardNumber': '卡號',
  'store.giftCard.list.table.balance': '餘額',
  'store.giftCard.list.table.status': '狀態',
  'store.giftCard.list.table.createTime': '創建時間',
  'store.giftCard.list.table.actions': '操作',
  'store.giftCard.list.table.view': '查看',

  'store.giftCard.details.title': '禮品卡詳情',
  'store.giftCard.details.basic': '基本信息',
  'store.giftCard.details.history': '使用記錄',
  'store.giftCard.details.cardNumber': '卡號',
  'store.giftCard.details.balance': '餘額',
  'store.giftCard.details.status': '狀態',
  'store.giftCard.details.createTime': '創建時間',
  'store.giftCard.details.phone': '手機號',
  'store.giftCard.details.email': '郵箱',
  'store.giftCard.details.modify.balance': '修改餘額',
  'store.giftCard.details.send.email': '發送郵件',
  'store.giftCard.details.send.phone': '發送短信',
  'store.giftCard.details.history.time': '時間',
  'store.giftCard.details.history.type': '類型',
  'store.giftCard.details.history.amount': '金額',
  'store.giftCard.details.history.balance': '餘額',
  'store.giftCard.details.history.operator': '操作人',
  'store.giftCard.details.history.description': '描述',

  'store.member.list.title': '會員列表',
  'store.member.list.create': '新建會員',
  'store.member.list.refresh': '刷新',
  'store.member.list.search.memberId': '會員號',
  'store.member.list.search.phone': '手機號',
  'store.member.list.search.email': '郵箱',
  'store.member.list.search.status': '狀態',
  'store.member.list.table.memberNumber': '會員號',
  'store.member.list.table.name': '姓名',
  'store.member.list.table.phone': '手機號',
  'store.member.list.table.points': '積分',
  'store.member.list.table.level': '等級',
  'store.member.list.table.status': '狀態',
  'store.member.list.table.createTime': '創建時間',
  'store.member.list.table.actions': '操作',
  'store.member.list.table.view': '查看',

  'store.member.details.title': '會員詳情',
  'store.member.details.basic': '基本信息',
  'store.member.details.points': '積分記錄',
  'store.member.details.memberNumber': '會員號',
  'store.member.details.name': '姓名',
  'store.member.details.phone': '手機號',
  'store.member.details.email': '郵箱',
  'store.member.details.birthday': '生日',
  'store.member.details.level': '等級',
  'store.member.details.points.current': '當前積分',
  'store.member.details.status': '狀態',
  'store.member.details.createTime': '創建時間',
  'store.member.details.modify.points': '修改積分',
  'store.member.details.send.email': '發送郵件',
  'store.member.details.send.phone': '發送短信',
  'store.member.details.points.history.time': '時間',
  'store.member.details.points.history.type': '類型',
  'store.member.details.points.history.amount': '數量',
  'store.member.details.points.history.balance': '餘額',
  'store.member.details.points.history.operator': '操作人',
  'store.member.details.points.history.description': '描述',

  'store.settings.title': '店鋪設置',
  'store.settings.basic': '基本設置',
  'store.settings.notification': '通知設置',
  'store.settings.security': '安全設置',
};
